<template>
  <v-dialog :value="isShow" max-width="1400" min-height="480">
    <v-card>
      <!-- 상단 제목 영역 -->
      <v-card-title class="pa-4 pb-0 d-block">
        <div class="grey--text text-caption mb-1">{{ videoInfo.categoryNm }}</div>
        <div class="text-h6 font-weight-bold mb-2">{{ videoInfo.title }}</div>
        <div class="blue--text font-weight-bold text-subtitle-1">
          시청 현황 : {{ videoInfo.viewMemberCnt }}명 / {{ videoInfo.totMemberCnt }}명
        </div>
      </v-card-title>

      <!-- 본문 텍스트 영역 -->
      <v-card-text class="pa-4 pt-2">
        <div class="font-weight-bold red--text mb-2">미시청 회원 목록</div>

        <v-data-table
            v-model="selectedRow"
            height="50vh"
            :headers="getHeader(headers)"
            :items="notWatchedList"
            item-key="index"
            ref="dataTable" fixed-header
            :items-per-page="-1"
            no-data-text="조회된 데이터가 없습니다"
            class="elevation-1"
            show-select
            mobile-breakpoint="md"
        >
          <template v-slot:item.telNum="{ value }">
            <div>{{ setTelNum(value) }}</div>
          </template>
          <template v-slot:item.ssno="{ value }">
            <div>{{ setSsnoMasking(value) }}</div>
          </template>
        </v-data-table>


      </v-card-text>

      <!-- 하단 버튼 영역 -->
      <v-card-actions class="pa-4 justify-end">
        <v-btn color="primary" @click="isSendAlimtalk">영상시청 안내 알림톡 발송</v-btn>
        <v-btn text @click="$emit('close')">닫기</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {LECTURE_DASHBOARD_TABLE} from "@/util/TableHeaders";
import TableMixin from "@/mixin/TableMixin";
import _ from "lodash";
import {axiosInstance} from "@/util/AxiosModule";

export default {
  name: "DashboardPopup",
  props: {
    isShow: Boolean,
    videoInfo: Object, // video 객체 전달
  },
  mixins: [TableMixin],
  data() {
    return {
      headers: LECTURE_DASHBOARD_TABLE,
      notWatchedList: [],
      loading: false,
      selectedRow: []
    };
  },
  watch: {
    isShow(value) {
      if (value) {
        if (!_.isEmpty(this.videoInfo)) {
          this.getUntrainedMemberList();
        }
      }
    }
  },
  methods: {
    async getUntrainedMemberList() {
      this.loading = true;
      try {
        const { data } = await axiosInstance.get("/admin/training/untrained-members", {
          params: {
            trainingId: this.videoInfo.trainingId
          }
        });
        if (data.length < 1) {
          this.notWatchedList = [];
        } else {
          let idx = 0;
          for (const item of data) {item["index"] = idx++}
          this.notWatchedList = data;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
      this.loading = false;
    },
    isSendAlimtalk() {
      this.showConfirm({
        message: `선택된 ${this.selectedRow.length}명의 사용자에게 알림톡을 발송하시겠습니까?`,
        successCallback: () => {
          this.sendAlimtalk();
        },
        failCallback: () => {
          return false;
        }
      })
    },
    // 알림톡 발송
    async sendAlimtalk() {
      const memberIdList = this.selectedRow.map(item => item.memberId).join(",");
      try {
        await axiosInstance.post("/admin/training/untrained-members-notify", [memberIdList], {
          params: {
            title: this.videoInfo.title
          }
        }).then(() => {
          this.showAlert({
            message: "발송이 완료되었습니다",
            successCallback: () => {
              this.$emit("close");
          }
          })
        })
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },

  }
};
</script>

<style scoped>
.fixed-height-table {
  min-height: 240px; /* 높이 default 설정 */
}

.custom-checkbox {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
</style>